<template>
    <div class="tw-bg-[#FBF6E8]">
        <section class="tw-mx-auto tw-max-w-5xl tw-px-6 tw-py-16 tw-text-center md:tw-py-20">
            <p class="tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-[0.22em] tw-text-gray-500">Massas e recheios</p>
            <h1 class="tw-font-serif tw-mx-auto tw-mt-5 tw-max-w-xl tw-text-4xl tw-leading-tight tw-text-[#3d2428] md:tw-text-6xl">
                O melhor detalhe?<br />
                <span class="tw-italic tw-text-secondary tw-text-secondary-400">O teu sabor.</span>
            </h1>
            <p class="tw-mx-auto tw-mt-6 tw-max-w-lg tw-text-base tw-leading-relaxed tw-text-gray-600">
                Estas são as massas e os recheios do atelier. Podes combinar mais do que um, e a Marina confirma a combinação contigo.
            </p>
        </section>

        <section class="tw-mx-auto tw-max-w-5xl tw-px-6 tw-pb-16">
            <p class="tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-[0.22em] tw-text-secondary-400">01 · A massa</p>
            <h2 class="tw-font-serif tw-mt-3 tw-text-3xl tw-text-[#3d2428] md:tw-text-4xl">Como começa a fatia</h2>

            <ul class="tw-mt-10 tw-grid tw-grid-cols-2 tw-gap-8 sm:tw-grid-cols-4">
                <li
                    v-for="dough in doughs"
                    :key="dough.name"
                    class="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-text-center">
                    <span
                        class="tw-h-20 tw-w-20 tw-rounded-full tw-border tw-border-black/10 tw-shadow-sm"
                        :style="{ backgroundColor: dough.color }"></span>
                    <span class="tw-text-sm tw-font-medium tw-text-secondary-400">{{ dough.name }}</span>
                </li>
            </ul>
        </section>

        <section class="tw-mx-auto tw-max-w-5xl tw-px-6 tw-pb-16">
            <p class="tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-[0.22em] tw-text-secondary-400">02 · O recheio</p>
            <h2 class="tw-font-serif tw-mt-3 tw-text-3xl tw-text-[#3d2428] md:tw-text-4xl">A outra metade</h2>

            <ul class="tw-mt-10 tw-grid tw-grid-cols-1 tw-gap-3 sm:tw-grid-cols-2">
                <li
                    v-for="filling in frostings"
                    :key="filling.name"
                    class="tw-flex tw-items-center tw-gap-4 tw-rounded-2xl tw-bg-white/70 tw-px-4 tw-py-3">
                    <span
                        class="tw-h-8 tw-w-8 tw-shrink-0 tw-rounded-full tw-border tw-border-black/10"
                        :style="{ backgroundColor: filling.color }"></span>
                    <span class="tw-text-sm tw-text-[#3d2428]">{{ filling.name }}</span>
                </li>
            </ul>
        </section>

        <section class="tw-mx-auto tw-max-w-5xl tw-px-6 tw-pb-20">
            <div class="tw-rounded-3xl tw-bg-secondary-400 tw-px-6 tw-py-10 tw-text-center tw-text-[#FBF6E8] md:tw-px-12">
                <h2 class="tw-font-serif tw-text-3xl md:tw-text-4xl">Leva a combinação para o pedido</h2>
                <p class="tw-mx-auto tw-mt-4 tw-max-w-xl tw-text-sm tw-leading-relaxed tw-text-[#FBF6E8]/85">
                    Se houver alergias ou restrições, diz no pedido. Escolher uma massa ou um recheio não garante ausência de alergénios nem de contacto cruzado.
                </p>
                <v-btn
                    :to="{ name: 'Order' }"
                    class="tw-mt-8 tw-rounded-full tw-bg-[#FBF6E8] tw-px-8 tw-normal-case tw-text-secondary-400"
                    size="large"
                    elevation="0">
                    Preparar o meu pedido
                    <v-icon
                        end
                        size="18"
                        >mdi-arrow-right</v-icon
                    >
                </v-btn>
            </div>
        </section>
    </div>
</template>

<script lang="ts" setup>
    import { doughs, frostings } from '@/data/flavors';
</script>
